import React from 'react';
import { useMobileContext } from '../../contexts/MobileContext';
import PageShell from '../Layout/PageShell';
import SubPageHero from './SubPageHero';

import ScrollFadeWrapper from '../ScrollFadeWrapper/ScrollFadeWrapper';
import QuoteCarouselComponent from '../HomePage/QuoteCarousel/QuoteCarouselComponent';

import PartnerBrandsComponent from '../../components/HomePage/PartnerBrands/PartnerBrandsComponent';
import PartnerBrandsMobileComponent from '../../components/HomePage/PartnerBrands/PartnerBrandsMobileComponent';
import partnerBrandsData from '../../json/components/HomePages/FuneralInsurance/partnerBrandsData.json';

import CustomerReviewsComponent from '../../components/HomePage/CustomerReviews/CustomerReviewsComponent';
import CustomerReviewsMobileComponent from '../../components/HomePage/CustomerReviews/CustomerReviewsMobileComponent';
import customerReviewsData from '../../json/components/HomePages/FuneralInsurance/customerReviewsData.json';

import AccordionFAQComponent from '../../components/HomePage/AccordionFAQ/AccordionFAQComponent';
import AccordionFAQMobileComponent from '../../components/HomePage/AccordionFAQ/AccordionFAQMobileComponent';
import accordionFAQData from '../../json/components/HomePages/FuneralInsurance/accordionFAQData.json';

import ScrollingCardsComponent from '../../components/HomePage/ScrollingCards/ScrollingCardsComponent';
import ScrollingCardsMobileComponent from '../../components/HomePage/ScrollingCards/ScrollingCardsMobileComponent';
import scrollingCardsData from '../../json/components/HomePages/FuneralInsurance/scrollingCardsData.json';
import scrollingCardsData2 from '../../json/components/HomePages/FuneralInsurance/scrollingCardsData2.json';
import scrollingCardsData3 from '../../json/components/HomePages/FuneralInsurance/scrollingCardsData3.json';

import FourBlogCardsComponent from '../../components/HomePage/FourBlogCards/FourBlogCardsComponent';
import FourBlogCardsMobileComponent from '../../components/HomePage/FourBlogCards/FourBlogCardsMobileComponent';
import fourBlogCardsData from '../../json/components/HomePages/FuneralInsurance/fourBlogCardsData.json';

import HippoGenericMobileComponent from '../../components/Banners/HippoGenericMobileComponent';
import HippoTwoLineGenericComponent from '../../components/Banners/HippoTwoLineGenericComponent';

import KeyPointVerticalNumericComponent from '../../components/HomePage/KeyPointVertical/KeyPointVerticalNumericComponent';
import KeyPointVerticalNumericFourMobileComponent from '../../components/HomePage/KeyPointVertical/KeyPointVerticalNumericFourMobileComponent';
import keyPointVerticalNumericData from '../../json/components/HomePages/FuneralInsurance/keyPointVerticalNumericData.json';

import SeoSnakeGuideComponent from '../../components/HomePage/SeoSnakeGuide/SeoSnakeGuideComponent';
import SeoSnakeGuideMobileComponent from '../../components/HomePage/SeoSnakeGuide/SeoSnakeGuideMobileComponent';
import snakeGuideData from '../../json/components/HomePages/FuneralInsurance/snakeGuideData.json';

import ThreeColumnCardComponent from '../../components/HomePage/ThreeColumnCard/ThreeColumnCardComponent';
import ThreeColumnCardMobileComponent from '../../components/HomePage/ThreeColumnCard/ThreeColumnCardMobileComponent';
import threeColumnCardData from '../../json/components/HomePages/FuneralInsurance/threeColumnCardData.json';

function FuneralInsurancePage({ pathName, heroGateKey, onHeroImageLoad }) {
  const isMobile = useMobileContext();
  const questionRoute = '/funeral-insurance-quote/step1';
  return (
    <PageShell gap={{ xs: '24px', sm: '48px', md: '64px' }}>
      <SubPageHero
        pathName={pathName}
        heroGateKey={heroGateKey}
        onImageLoad={onHeroImageLoad}
      />

      <QuoteCarouselComponent
        crossSellKey="latestFuneralInsuranceQuotes_CrossSell"
        fallbackKey="latestFuneralQuotes"
        navigateTo="/funeral-insurance-quote/step1"
      />

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <PartnerBrandsComponent data={partnerBrandsData} />
        ) : (
          <PartnerBrandsMobileComponent data={partnerBrandsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <KeyPointVerticalNumericComponent
            data={keyPointVerticalNumericData}
          />
        ) : (
          <KeyPointVerticalNumericFourMobileComponent
            data={keyPointVerticalNumericData}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CustomerReviewsComponent data={customerReviewsData} />
        ) : (
          <CustomerReviewsMobileComponent data={customerReviewsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <SeoSnakeGuideComponent data={snakeGuideData} />
        ) : (
          <SeoSnakeGuideMobileComponent data={snakeGuideData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ScrollingCardsComponent data={scrollingCardsData2} />
        ) : (
          <ScrollingCardsMobileComponent data={scrollingCardsData2} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <HippoTwoLineGenericComponent
            route={questionRoute}
            image={'HippoTickle'}
            title={'Find a better deal on family funeral cover'}
            color={'blue'}
            imageDirection={'right'}
            buttonText={'Compare plans'}
          />
        ) : (
          <HippoGenericMobileComponent
            route={questionRoute}
            image={'HippoTickle'}
            title={'Find a better deal on family funeral cover'}
            color={'blue'}
            buttonText={'Compare plans'}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ThreeColumnCardComponent data={threeColumnCardData} />
        ) : (
          <ThreeColumnCardMobileComponent data={threeColumnCardData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ScrollingCardsComponent data={scrollingCardsData3} />
        ) : (
          <ScrollingCardsMobileComponent data={scrollingCardsData3} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <FourBlogCardsComponent
            data={fourBlogCardsData}
            tag="funeral-insurance"
          />
        ) : (
          <FourBlogCardsMobileComponent
            data={fourBlogCardsData}
            tag="funeral-insurance"
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <AccordionFAQComponent data={accordionFAQData} />
        ) : (
          <AccordionFAQMobileComponent data={accordionFAQData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <HippoTwoLineGenericComponent
            route={questionRoute}
            image={'HippoArmsCrossed'}
            title={'Your easiest way to find better funeral cover'}
            color={'blue'}
            buttonText={'Compare plans'}
          />
        ) : (
          <HippoGenericMobileComponent
            route={questionRoute}
            image={'HippoArmsCrossed'}
            title={'Your easiest way to find better funeral cover'}
            color={'blue'}
            buttonText={'Compare plans'}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ScrollingCardsComponent data={scrollingCardsData} />
        ) : (
          <ScrollingCardsMobileComponent data={scrollingCardsData} />
        )}
      </ScrollFadeWrapper>
    </PageShell>
  );
}

export default FuneralInsurancePage;
